export default __webpack_public_path__ + "static/media/guys-climbers.c7e7d2c0.jpeg";